export const getPartnerButtonText = (partnerType) => {
  const partnerTypesToButtonText = []

  partnerTypesToButtonText['dealer'] = 'Contact Dealer'
  //add new partnerTypestoButtonText here.

  return partnerTypesToButtonText[partnerType]
    ? partnerTypesToButtonText[partnerType]
    : 'Contact'
}

export const getPartnerContactFormText = (partnerType) => {
  const partnerTypesToContactFormText = []

  partnerTypesToContactFormText['dealer'] = 'Contact Dealer'
  //add new partnerTypesToContactFormText here.

  return partnerTypesToContactFormText[partnerType]
    ? partnerTypesToContactFormText[partnerType]
    : 'Contact Form'
}
